export default "__VITE_ASSET__B9V$qwju__"